// structuredClone is missing in older browsers (Chrome/Edge < 98, Safari < 15.4,
// Firefox < 94) and old in-app webviews — the segment behind Sentry 7590550536.
// Chakra UI v3's useRecipe calls structuredClone on every styled component render,
// sometimes with `undefined` (no recipe registered for the key). JSON.stringify
// returns undefined for undefined/function/symbol roots, and JSON.parse(undefined)
// throws `"undefined" is not valid JSON` — so those roots are passed through as-is.
export function structuredClonePolyfill<T>(obj: T): T {
  const json = JSON.stringify(obj);
  return json === undefined ? obj : JSON.parse(json);
}

export function arrayAtPolyfill<T>(this: ArrayLike<T>, index: number): T | undefined {
  const length = Math.max(0, Math.trunc(Number(this.length)) || 0);
  if (length === 0) return undefined;

  const relativeIndex = Math.trunc(Number(index)) || 0;
  const absoluteIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
  if (absoluteIndex < 0 || absoluteIndex >= length) return undefined;

  return this[absoluteIndex];
}

// NOTE: package.json has "sideEffects": false, so a bare `import "./polyfills"`
// gets tree-shaken out of the production bundle. main.tsx must import this
// function and call it explicitly.
export function installStructuredClonePolyfill(): void {
  if (typeof globalThis.structuredClone === "undefined") {
    globalThis.structuredClone = structuredClonePolyfill;
  }
}

export function installArrayAtPolyfill(): void {
  if (typeof Array.prototype.at !== "function") {
    Object.defineProperty(Array.prototype, "at", {
      value: arrayAtPolyfill,
      configurable: true,
      writable: true,
    });
  }
}
